import { PanelGroup } from 'components/shared/PanelGroup/PanelGroup';
import { WithToggle } from 'components/shared/WithToggle/WithToggle';
import { CollapseErrorDetails } from 'components/shared/WorkflowError/CollapseDetails';
import { useWorkflowErrorsUtils } from 'hooks/useWorkflowErrorsUtils';
import { FC } from 'react';
import { Alert } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { WorkflowErrorDetailsItemLegacy } from './WorkflowErrorDetailsItemLegacy';
import type { WorkflowErrorDetailsListProps } from './WorkflowErrorDetailsList';

const id = 'errors-panel-details-list';

/**
 * @deprecated Use <WorkflowErrorDetailsItem />
 */
export const WorkflowErrorDetailsListLegacy: FC<WorkflowErrorDetailsListProps> = ({
  height,
  useLegacyWorkFlowError = false,
  useMaxHeight = false,
  workflowErrors,
}) => {
  const { formatMessage } = useIntl();
  const { getWorkflowErrorMessage } = useWorkflowErrorsUtils();

  const hasErrors = workflowErrors.length > 0;
  const hasOnlyOneError = workflowErrors.length === 1;

  return (
    <ScrollableDiv
      className={`${id}-component ${hasOnlyOneError ? 'has-only-one-error' : ''} `}
      data-e2e={id}
      $height={height}
      id={id}
      $useMaxHeight={useMaxHeight}
    >
      {hasErrors && (
        <PanelGroup e2e={`${id}-panel-group`} id={`${id}-panel-group`}>
          {workflowErrors.map((workflowError, index: number) => (
            <WithToggle isInitiallyOn={hasOnlyOneError} key={index}>
              {({ isOn, toggle }) => (
                <div className="border border-top-0  my-3" data-e2e={`${id}-panel`}>
                  <CollapseErrorDetails
                    canOpen={true}
                    isOpen={isOn}
                    toggleOpen={toggle}
                    title={formatPanelTitle(getWorkflowErrorMessage(workflowError))}
                  >
                    <WorkflowErrorDetailsItemLegacy
                      useLegacyWorkFlowError={useLegacyWorkFlowError}
                      workflowError={workflowError}
                    />
                  </CollapseErrorDetails>
                </div>
              )}
            </WithToggle>
          ))}
        </PanelGroup>
      )}

      {!hasErrors && (
        <Alert variant="danger">
          <strong>{formatMessage({ id: 'errorDetails.errorDetailsCanNotBeDisplayed' })}</strong>
          &nbsp;
          {formatMessage({ id: 'pleaseContactSupport' })}
        </Alert>
      )}
    </ScrollableDiv>
  );
};

const maxLengthForPanelTitle = 90;

const formatPanelTitle = (title: string): string => {
  return title.length > maxLengthForPanelTitle ? title.slice(0, maxLengthForPanelTitle).trim() + '...' : title;
};

interface ScrollableDivProps {
  $height?: string;
  $useMaxHeight?: boolean;
}
const ScrollableDiv = styled.div<ScrollableDivProps>`
  overflow-y: auto;
  ${p => p.$useMaxHeight && 'max-'}height: ${p => p.$height ?? '40em'};
`;
